import { Component, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { MatMenuItem } from '@angular/material/menu';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { faBars, faTimes, IconDefinition } from '@fortawesome/free-solid-svg-icons';

import { MemberSelectors } from 'src/app/member';
import { PagesDataActions, PagesSelectors } from 'src/app/pages';
import { ClientSelectors, FundType } from 'src/app/client';
import { MenuItem } from './menu-item-model';
import { MemberInfo } from 'src/app/member/models/member';
import { AppDataActions } from '../..';
import { MetadataModels, MetadataSelectors } from 'src/app/metadata';
import { BenefitItem, BenefitResponse } from 'src/app/pages/models/page.model';
import { getBenefitList } from 'src/app/pages/state/pages.selectors';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MemberService } from 'src/app/member/services/member-service';
import { PropertyType } from 'src/app/client/types';
import * as PageAction from 'src/app/pages/state/pages.actions';


@Component({
    selector: 'menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
    menuList: MenuItem[];
    menuIcon: IconDefinition = faBars;
    subs: Subscription = new Subscription();
    idx: number = 0;
    @ViewChildren('menuItems') private menuItemsRef: QueryList<MatMenuItem>;
    readonly ATTACHMENT_KEY = '#attachment';
    properties: MetadataModels.Property[];
    TEMPLATE_KEY: any = {
        SupportContact: "supportContact",
        Subheader: "subheader",
        PropertyList: "propertyList",
        PropertyListLayout: "propertyListLayout",
        PropertyTable: "propertyTable",
        Footnote: "footnote",
        Attachment: "attachment",
        AttachmentText: "attachmentText"
    };
    selectedBenefit?: BenefitItem;
    unsubscribe$ = new Subject<void>()
    public benefits: BenefitItem[] = [];
    years: any[]
    payments: any[]
    yearObj: any = {};
    paymentTemps: any[]
    yearFilter: string = 'All'

    constructor(private store: Store, private router: Router, private memberService: MemberService,) {
        this.menuList = [];
    }

    ngDestroy(): void {
        this.subs.unsubscribe();
    }

    ngOnInit(): void {
        this.subs.add(
            combineLatest([
                this.store.select(PagesSelectors.getPages),
                this.store.select(MetadataSelectors.getAll),
                this.store.select(MemberSelectors.getMember),
                this.store.select(ClientSelectors.getClient),
            ]).subscribe(([pages, mmds, mb, client]) => {
                this.properties = mmds;
                if (!(pages)) {
                    return;
                }
                let result = [];

                if (mb) {
                    const propertyName = Object.keys(mb?.memberInfo?.propertyList).find(item => item.includes('.Name'));
                    const propertyValue = mb?.memberInfo?.propertyList[propertyName];
                    const userName = this.getConcatString([propertyValue.first, propertyValue.middle, propertyValue.last], ' ');

                    localStorage.setItem('memberName', userName);
                    this.store.dispatch(AppDataActions.setUserName({ userName }));
                }

                pages
                    .filter(page => !(page.template === 'memberDetail' && page.content?.length === 0))
                    .forEach(pg => {
                        var menuItem: MenuItem = {
                            label: pg.navigation,
                            href: `pages/${pg.id}`,
                            isHidden: false
                        };

                        if (this.properties && mb) {
                            if (pg.template === 'memberDetail') {
                                let propertyListContent = pg.content.find(c => c.key === this.TEMPLATE_KEY.PropertyList);
                                if (propertyListContent) {
                                    for (let idx in propertyListContent.value) {
                                        let parts = propertyListContent.value[idx].split('.');
                                        if (parts[0]?.includes(this.ATTACHMENT_KEY)) {
                                            continue;
                                        }

                                        let mdp = this.properties.find(x => (x.entityPropertyId === parts[1]));

                                        if (mdp) {
                                            const propertyList = mb?.memberInfo.propertyList;
                                            const retirementCalcKey = Object.keys(propertyList).find((key) => {
                                                const splitKey = key.split('.');
                                                if (parts?.[6]) {
                                                    return splitKey?.[0] === mdp.entityPropertyId && parts[6] === splitKey?.[3];
                                                }
                                                return splitKey?.[0] === mdp.entityPropertyId;
                                            });

                                            let mdv = propertyList[retirementCalcKey] ?? null;
                                            if (mdv !== null) {
                                                menuItem.isHidden = false;
                                                break;
                                            }
                                            else {
                                                menuItem.isHidden = true;
                                            }
                                        }
                                    }
                                } else {
                                    let propertyTableContent = pg.content.find(c => c.key === this.TEMPLATE_KEY.PropertyTable);
                                    if (propertyTableContent?.value != null) {
                                        const propertyTable = mb.memberInfo.propertyTable ?? [];
                                        const contentValues = (Object.values(propertyTableContent.value) as string[]);
                                        const guidRegex = /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/;
                                        const entityComponentId = contentValues.find(value => guidRegex.test(value.split('.')[0]));
                                        if (contentValues?.length) {
                                            // Property table value
                                            const values = propertyTable.filter(data => data.entityComponentId === entityComponentId).map(data => {
                                                return {
                                                    ...Object.keys(data).reduce((acc, key) => {
                                                        let value = data[key];
                                                        const keySplit = key.split('.');

                                                        if (+keySplit[2] === PropertyType.Tier) {
                                                            value = mb.tiers.find(tier => tier.id === value)?.tierName;
                                                        }

                                                        if (key === 'targetId') {
                                                            return { ...acc, [key]: value };
                                                        }

                                                        return ({ ...acc, [`${keySplit[0]}${keySplit?.[3] ? `.${keySplit[3]}` : ''}`]: [value, keySplit[2]] });
                                                    }, {}), isSelected: false
                                                }
                                            });
                                            menuItem.isHidden = values.length === 0;
                                        } else {
                                            menuItem.isHidden = true;
                                        }
                                    }
                                }
                            }

                            if (pg.template === 'payrollHistory' || pg.template == 'payeeProfile') {
                                if ((pg.template === 'payrollHistory' && !pg.content.some(c => c.key === 'payrollHistory'))
                                   || (pg.template === 'payeeProfile' && !pg.content.some(c => c.key === 'payeeProfile'))) {
                                    menuItem.isHidden = true;
                                } else {
                                    this.store.dispatch(PageAction.getBenefitList());
                                    this.store.select(getBenefitList).pipe(
                                        takeUntil(this.unsubscribe$),
                                    ).subscribe(el => {
                                        if (el && el.headerBenefits?.length === 0) {
                                            menuItem.isHidden = true;
                                        } else {
                                            this.benefits = [];
                                        }
                                    });
                                }
                            }

                            if (pg.template === 'retirementCalc') {
                                if (client?.fundType === FundType.MobileAL) {
                                    menuItem.isHidden = !(mb?.status.toLocaleLowerCase() === 'active');
                                } else if (client?.fundType === FundType.ChicagoLabor) {
                                    let contentValues = pg.content.filter(cnt => cnt.key.endsWith("Value") && cnt.parentKey === 'estimatorAccessibility')[0];
                                    if (contentValues != null) {
                                        var metadataKey = contentValues.value[0];
                                        this.store.select(MemberSelectors.resolveMetadata, metadataKey).subscribe(mdProp => {
                                            menuItem.isHidden = mdProp != "true";
                                        });
                                    }

                                }
                                if (!(mb as MemberInfo)?.isMember) {
                                    menuItem.isHidden = true;
                                }
                                localStorage.setItem('fundKey', client?.key);
                                localStorage.setItem('fundType', client?.fundType?.toString());
                            }
                            if (!menuItem.isHidden) {
                                result.push(menuItem);
                            }
                            localStorage.setItem('fundKey', client?.key);

                        }
                    });
                if (result.length > 0) {
                    this.menuList = result;
                }
            })
        );
    }

    getConcatString(values: string[], separator: string = ', ') {
        return values.filter(value => value).join(separator);
    }

    itemClick(item: MenuItem, i: number): void {
        this.store.dispatch(PagesDataActions.loadPages());
        this.idx = i;
        this.router.navigate([item.href], {
            fragment: window.location.getClientDomain()
        });

    }

    menuOpened(): void {
        this.menuIcon = faTimes;
        const item = this.menuItemsRef.find((item, index, array) => {
            return index == this.idx;
        });
        setTimeout(() => {
            item.focus();
        }, 0);
    }

    menuClosed(): void {
        this.menuIcon = faBars;
    }
}